import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Grid,
  MenuItem,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

const AdvanceSearchModal = ({
  open,
  openHandler,
  submitClickHandler,
  handleFilterReset,
  formInitialValues,
  reportsToList,
}) => {
  const validationSchema = Yup.object({});

  return (
    <Dialog open={open} onClose={openHandler} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <>Advanced Search</>
        <CloseIcon
          onClick={openHandler}
          color="primary"
          sx={{ cursor: "pointer" }}
        />
      </DialogTitle>

      <DialogContent>
        <Formik
          initialValues={{
            name: formInitialValues?.name || "",

            employeeId: formInitialValues?.employeeId || "",
            userName: formInitialValues?.userName || "",
            designation: formInitialValues?.designation || "",
            department: formInitialValues?.department || "",
            track: formInitialValues?.track || "",
            reportsTo: formInitialValues?.reportsTo || "",
            dojTimeRange: {
              from: formInitialValues?.dojTimeRange?.from || "",
              to: formInitialValues?.dojTimeRange?.to || "",
            },
            emailId: formInitialValues?.emailId || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            submitClickHandler(values);
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={2} sx={{ p: 1 }}>
                {[
                  { name: "name", label: "Name", type: "input" },
                  { name: "employeeId", label: "Employee Id", type: "input" },
                  { name: "userName", label: "User Name", type: "input" },

                  { name: "designation", label: "Designation", type: "input" },
                  { name: "department", label: "Department", type: "input" },
                  {
                    name: "track",
                    label: "Track",
                    type: "input",
                  },
                  {
                    name: "reportsTo",
                    label: "Reports To",
                    type: "select",
                  },
                  {
                    name: "emailId",
                    label: "Email Id",
                    type: "input",
                  },
                  {
                    name: "phoneNumber",
                    label: "Phone Number",
                    type: "input",
                  },
                  // {
                  //   name: "assetIdList",
                  //   label: "Asset ID List",
                  //   type: "select",
                  // },
                ].map((field) => (
                  <>
                    {field?.type === "input" ? (
                      <Grid item xs={12} md={6} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              size="small"
                              label={field.label}
                              type={
                                field.type === "checkbox" ? "checkbox" : "text"
                              }
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            />
                          )}
                        </Field>
                      </Grid>
                    ) : field.type === "select" ? (
                      <Grid item xs={12} md={6}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <TextField
                              {...formikField}
                              variant="outlined"
                              size="small"
                              label={field.label}
                              renderValue={(selected) => {
                                if (selected.length === 0) {
                                  return <em>Placeholder</em>;
                                }

                                return selected.join(", ");
                              }}
                              select
                              onChange={(event) => {
                                props.setFieldValue(
                                  field.name,
                                  event.target.value
                                );
                              }}
                              fullWidth
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                            >
                              {reportsToList?.map((val) => {
                                return (
                                  <MenuItem key={val.userId} value={val.userId}>
                                    {`${val.userId} : ${val.name}`}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          )}
                        </Field>
                      </Grid>
                    ) : null}
                  </>
                ))}
              </Grid>

              <DialogActions>
                <Button onClick={handleFilterReset}>Reset</Button>
                <Button type="submit" variant="contained">
                  Apply
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default AdvanceSearchModal;
